import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
export const SuccessfulMessage = (props) => {
    const { message, isError = false } = props
    return (
        <div className={isError ? 'ErrorDialogWrap' : "successAndErrorDialogWrap"}>
            <div className="icons">
                {isError ?
                    <HighlightOffIcon sx={{ width: '38px', height: '38px', color: '#F05924' }} />
                    : <CheckCircleIcon sx={{ width: '38px', height: '38px', color: '#3C763C' }} />
                }
            </div>
            <div className="message">
                {message}
            </div>
        </div>)
}